import { useState, useEffect, useRef } from "react";
import { CiFilter } from "react-icons/ci";
import { MdCancel } from "react-icons/md";

import { RiCheckLine } from 'react-icons/ri';
import { RiRefreshLine } from 'react-icons/ri';  // For Reset button

import { RiArrowDownSLine } from "react-icons/ri";
import searchIcon from "../../../../assets/admin/search.svg";
import { FaTimes } from "react-icons/fa";
// import OrderSearchBar from './OrderSearchBar';

const OrderWineFilter = (props) => {
  const {
    showOption,
    setShowOption,

    filteredNation,
    filteredRegion,
    filteredWine,
    filteredProductType,
    // filteredCategoryType,

    handleNationFilter,
    handleRegionFilter,
    handleWineFilter,
    handleProductTypeFilter,
    // handleCategoryTypeFilter,

    filteredNationArrays,
    filteredRegionArrays,
    filteredWineArrays,
    filteredProductTypeArrays,
    // filteredCategoryTypeArrays,

    // searchWine,
    searchQuery,
    setSearchQuery,
    // setSearchWine,
    getWineData,
    setPage,

    // searchCodice,
    // setSearchCodice,
    // searchNome,
    // setSearchNome,

    // setAllwinesData
  } = props;

  const dropdownRef = useRef(null);

  const [showFilterForMobile, setShowFilterForMobile] = useState(false);

  // State Management: Dropdown Options
  // const [showOption, setShowOption] = useState({
  //     nation: false,
  //     region: false,
  //     wine: false,
  //     product_type: false,
  // });

  // Toggle Dropdown for Filter Options
  const toggleDropdown = (key) => {
    setShowOption((prev) => ({
      nation: false,
      region: false,
      wine: false,
      product_type: false,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOption({
          nation: false,
          region: false,
          wine: false,
          product_type: false,
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShowFilterForMobile(false);
    }
  };
  const handleResize2 = () => {
    if (window.innerWidth <= 768) {
      setShowFilterForMobile(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize2);
    return () => {
      window.removeEventListener("resize", handleResize2);
    };
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOption({ stato: false });
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      {(filteredNation.length > 0 ||
        filteredRegion.length > 0 ||
        filteredWine.length > 0 ||
        filteredProductType.length > 0 
        // filteredCategoryType.length > 0
      ) && (
        <div className="flex flex-col  pt-2 pb-1">
          <h1 className="text-lg mb-3 font-medium">Filtri Selezionati</h1>
          <div className="flex flex-wrap gap-3">
            {filteredNation.length > 0 &&
              filteredNation?.map((item) => {
                return (
                  <div
                    key={item}
                    className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    <p className="m-0 w-fit text-sm">{item}</p>
                    <FaTimes
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleNationFilter(item)}
                      title="Remove"
                    />
                  </div>
                );
              })}
            {filteredRegion.length > 0 &&
              filteredRegion?.map((item) => {
                return (
                  <div
                    key={item}
                    className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    <p className="m-0 w-fit text-sm">{item}</p>
                    <FaTimes
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleRegionFilter(item)}
                      title="Remove"
                    />
                  </div>
                );
              })}
            {filteredWine.length > 0 &&
              filteredWine?.map((item) => {
                return (
                  <div
                    key={item}
                    className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    <p className="m-0 w-fit text-sm">{item}</p>
                    <FaTimes
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleWineFilter(item)}
                      title="Remove"
                    />
                  </div>
                );
              })}
            {filteredProductType.length > 0 &&
              filteredProductType?.map((item) => {
                return (
                  <div
                    key={item}
                    className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    <p className="m-0 w-fit text-sm">{item}</p>
                    <FaTimes
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleProductTypeFilter(item)}
                      title="Remove"
                    />
                  </div>
                );
              })}

            {/* {filteredCategoryType.length > 0 &&
              filteredCategoryType?.map((item) => {
                return (
                  <div
                    key={item}
                    className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    <p className="m-0 w-fit text-sm">{item}</p>
                    <FaTimes
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleCategoryTypeFilter(item)}
                      title="Remove"
                    />
                  </div>
                );
              })} */}
          </div>
        </div>
      )}

      <div className="w-full flex gap-3 items-center my-5 justify-center flex-wrap">
        <div className="w-full flex xl:flex-row flex-col gap-2 justify-between">
          <div className="w-full">
            <div ref={dropdownRef}>
              <h1 className="text-xl flex items-center justify-between italic font-bold poppins-medium mb-3">
                Scegli i vini:
                <div className="sm:hidden block">
                  {showFilterForMobile ? (
                    <CiFilter
                      onClick={() => {
                        setShowFilterForMobile(!showFilterForMobile);
                      }}
                      color="gray"
                      size={"30px"}
                    />
                  ) : (
                    <MdCancel
                      onClick={() => {
                        setShowFilterForMobile(!showFilterForMobile);
                      }}
                      color="gray"
                      size={"30px"}
                    />
                  )}
                </div>
              </h1>

              <div
                className={`${
                  showFilterForMobile
                    ? "hidden transition-all duration-500 ease-in-out"
                    : ""
                } grid my-3 xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-2 gap-3`}
              >
                {/* Nation Filter */}
                <div className="relative group w-full dropdown-container">
                  <button
                    className={`${
                      showOption.nation
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                    } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("nation")}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      Nazione
                    </span>
                    <RiArrowDownSLine
                      className={`132 transform transition-transform duration-300 ${
                        showOption.nation ? "rotate-180" : ""
                      }`}
                      size={"20px"}
                    />
                  </button>
                  <div
                    className={`${
                      showOption.nation
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 hidden"
                    } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                        placeholder="..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    {filteredNationArrays?.length > 0 ? (
                      filteredNationArrays?.map((nation) => (
                        <label
                          htmlFor=""
                          key={nation}
                          className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                        >
                          <input
                            type="checkbox"
                            className="outline-none cursor-pointer"
                            checked={filteredNation.includes(nation)}
                            onChange={() => handleNationFilter(nation)}
                          />
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {nation}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        htmlFor=""
                        className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          No nazione data available
                        </span>
                      </label>
                    )}
                  </div>
                </div>

                {/* Region Filter */}
                <div className="relative group w-full dropdown-container">
                  <button
                    className={`${
                      showOption.region
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                    } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("region")}
                  >
                    <span className="mr-2flex items-center gap-3 poppins-medium">
                      Regione
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${
                        showOption.region ? "rotate-180" : ""
                      }`}
                      size={"20px"}
                    />
                  </button>
                  <div
                    className={`${
                      showOption.region
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 hidden"
                    } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                        placeholder="..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    {filteredRegionArrays?.length > 0 ? (
                      filteredRegionArrays?.map((region) => (
                        <label
                          htmlFor=""
                          key={region}
                          className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                        >
                          <input
                            type="checkbox"
                            className="outline-none cursor-pointer"
                            checked={filteredRegion.includes(region)}
                            onChange={() => handleRegionFilter(region)}
                          />
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {region}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        htmlFor=""
                        className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          No regione data available
                        </span>
                      </label>
                    )}
                  </div>
                </div>

                {/* Wine Filter */}
                <div className="relative group  w-full dropdown-container">
                  <button
                    className={`${
                      showOption.wine
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                    } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("wine")}
                  >
                    <span className="mr-2flex items-center gap-3 poppins-medium">
                      Vitigno
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${
                        showOption.wine ? "rotate-180" : ""
                      }`}
                      size={"20px"}
                    />
                  </button>
                  <div
                    className={`${
                      showOption.wine
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 hidden"
                    } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                        placeholder="..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    {filteredWineArrays?.length > 0 ? (
                      filteredWineArrays?.map((wine) => (
                        <label
                          htmlFor=""
                          key={wine}
                          className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                        >
                          <input
                            type="checkbox"
                            className="outline-none cursor-pointer"
                            checked={filteredWine.includes(wine)}
                            onChange={() => handleWineFilter(wine)}
                          />
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {wine}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        htmlFor=""
                        className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          No vitigno data available
                        </span>
                      </label>
                    )}
                  </div>
                </div>

                {/* Product Type Filter */}
                <div className="relative group w-full dropdown-container">
                  <button
                    className={`${
                      showOption.product_type
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                    } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("product_type")}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      Tipologia
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${
                        showOption.product_type ? "rotate-180" : ""
                      }`}
                      size={"20px"}
                    />
                  </button>
                  <div
                    className={`${
                      showOption.product_type
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 hidden"
                    } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                        placeholder="..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    {filteredProductTypeArrays?.length > 0 ? (
                      filteredProductTypeArrays?.map((productType) => (
                        <label
                          htmlFor=""
                          key={productType}
                          className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                        >
                          <input
                            type="checkbox"
                            checked={filteredProductType.includes(productType)}
                            className="outline-none cursor-pointer"
                            onChange={() =>
                              handleProductTypeFilter(productType)
                            }
                          />
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {productType}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        htmlFor=""
                        className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          No tipologia data available
                        </span>
                      </label>
                    )}
                  </div>
                </div>

                {/* Category Type Filter */}
                {/* <div className="relative group w-full dropdown-container">
                  <button
                    className={`${
                      showOption.category_type
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                    } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                    onClick={() => toggleDropdown("category_type")}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      Categoria
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${
                        showOption.category_type ? "rotate-180" : ""
                      }`}
                      size={"20px"}
                    />
                  </button>
                  <div
                    className={`${
                      showOption.category_type
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 hidden"
                    } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                      <img
                        src={searchIcon}
                        className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                        alt="Search"
                      />
                      <input
                        type="text"
                        className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                        placeholder="..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    {filteredCategoryTypeArrays?.length > 0 ? (
                      filteredCategoryTypeArrays?.map((categoryType) => (
                        <label
                          htmlFor=""
                          key={categoryType}
                          className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                        >
                          <input
                            type="checkbox"
                            checked={filteredCategoryType.includes(
                              categoryType
                            )}
                            className="outline-none cursor-pointer"
                            onChange={() =>
                              handleCategoryTypeFilter(categoryType)
                            }
                          />
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {categoryType}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        htmlFor=""
                        className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          No Categoria data available
                        </span>
                      </label>
                    )}
                  </div>
                </div> */}
              </div>
                <div className="flex gap-3 mt-5 mb-3">
                  <button
                    className="w-auto flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                    onClick={() => {
                      setPage(1);
                      getWineData();
                    }}
                  >
                     <RiCheckLine className="w-4 h-4 mr-2" />
                    <span className="poppins-regular text-sm">Applica</span>
                  </button>
                  <button
                    className="w-auto flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                    onClick={() => {
                      setPage(1);
                      getWineData("clear");
                    }}
                  >
                    <RiRefreshLine className="w-4 h-4 mr-2" />
                    <span className="poppins-regular text-sm">Reimposta</span>
                  </button>
                </div>
            </div>

            {/* <div className="input-type">
                            <div className="relative group xl:w-[400px]">
                                <button
                                    className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                                >
                                    <input
                                        type="text"
                                        placeholder="Nome"
                                        className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                                        value={searchWine || ""}
                                        onChange={(e) => {
                                            getWineData("name", e);
                                            setSearchWine(e.target.value);
                                        }}
                                    />

                                    <img
                                        src={searchIcon}
                                        className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                                        alt="Search"
                                    />
                                </button>
                            </div>
                        </div> */}

            {/* <OrderSearchBar
                            getWineData={getWineData}
                            searchWine={searchWine}
                            setSearchWine={setSearchWine}

                            searchCodice={searchCodice}
                            setSearchCodice={setSearchCodice}
                            searchNome={searchNome}
                            setSearchNome={setSearchNome}

                            setAllwinesData={setAllwinesData}
                        /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderWineFilter;
